<template>
  <div>
    <main class="main">
      <div class="container client_container">
        <section class="about">
          <div class="about_text">
            <div class="about_wrap">
              <h1 class="about_title">{{ clientTitle }}</h1>
              <p class="about_introduction font_m">{{ introduction }}</p>
            </div>
          </div>

          <div class="about_banner">
            <div class="scroll">
              <div class="vertical_text">SCROLL</div>
            </div>
            <div class="banner" v-if="bannersList.length !== 0">
              <CourseListBanner :bannersList="filterBanner"/>
            </div>
          </div>
        </section>

        <section ref="categorys" v-if="client_category.length !== 0" class="category_list">
          <CourseListCategory
            :clientCategory="client_category"
            v-on:category-id="filterCourseList"
          />
        </section>

        <section class="client_channels" ref="channels">
          <ul class="client_list">
            <li class="client_item" v-for="orgData in paginationClassData" :key="orgData.id" >
              <div class="item_flex">
                <figure>
                  <img v-bind:src="orgData.channel.author.imgAvatar" class="org_img">
                </figure>
                <figcaption>
                  <div class="item_content">
                    <h3 class="item_title font_l ellipsis_twoLine">{{ orgData.channel.title }}</h3>
                    <p class="font_m text-grey ellipsis_oneLine item_content_text">{{ orgData.channel.subtitle }}</p>
                    <p class="item_author font_m ellipsis_oneLine">{{ orgData.channel.author.title }}</p>
                  </div>

                  <div class="item_info">
                    <div class="text-grey font_m item_content_text">{{ orgData.channel.total }}集</div>
                    <div
                      class="text-main font_m item_content_text"
                      v-show="orgData.total_copy !== 99999">可借聽數{{ orgData.total_copy }}</div>
                  </div>
                </figcaption>
              </div>
              <router-link v-bind:to="`/org/${ clientId }/${orgData.channel.id}`" class="client_item_link" />
            </li>
          </ul>
        </section>
        <div v-show="totalPages > 1" class="pagiContainer">
          <CourseListPagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            v-on:change-list-page="changeListPage"
          />
        </div>
        <ClientsQRcode />
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// import functionJs from '@/assets/js/function_index.js'
import { mapGetters } from 'vuex'
import 'swiper/swiper-bundle.min.css'
import ClientsQRcode from '../components/ClientsQRcode'
import CourseListBanner from './components/CourseListBanner'
import CourseListCategory from './components/CourseListCategory'
import CourseListPagination from './components/CourseListPagination'

export default {
  name: 'ClientsCourseList',
  metaInfo () {
    return {
      title: `${this.clientTitle} | 一刻鯨選`,
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: `${this.clientTitle} | 一刻鯨選` },
        { property: 'og:site_name', content: `${this.clientTitle} | 一刻鯨選` },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },
  components: {
    ClientsQRcode,
    CourseListBanner,
    CourseListCategory,
    CourseListPagination
  },
  computed: {
    ...mapGetters([
      'clientTitle'
    ]),
    filterBanner () {
      return this.bannersList.filter(banner => banner.action.includes('https'))
    }
  },
  data () {
    return {
      introduction: '',
      clientData: [],
      client_category: [],
      bannersList: [],
      client_assets: [],
      pageUrl: '',
      clientId: '',

      api_current_page: 1,
      currentPage: 1,
      totalPages: 1,
      paginationClassData: []

      // 測試用data START
      // addBannersList: [
      //   {
      //     id: 456,
      //     type: 1,
      //     url: 'https://test.jinfm.net/images/clients/14/P5FfQ2.jpg',
      //     actionType: 2,
      //     action: 'https://business/intro/0'
      //   },
      //   {
      //     id: 36,
      //     type: 2,
      //     url: 'https://prod.jinfm.net/images/channels/36/cover.jpg',
      //     actionType: 2,
      //     action: 'https://business/intro/0'
      //   },
      //   {
      //     id: 55,
      //     type: 1,
      //     url: 'https://prod.jinfm.net/images/channels/4/cover.jpg',
      //     actionType: 2,
      //     action: 'inapp://business/intro/0'
      //   }
      // ],
      // add_assets: [
      //   {
      //     id: 416,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 516,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 526,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 536,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 546,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 556,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 566,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 576,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 586,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 596,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 16,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 834,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 863,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8667,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8632,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8614,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8617,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8618,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8619,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8621,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8622,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8623,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   },
      //   {
      //     id: 8624,
      //     channel: {
      //       id: 61,
      //       title: '古典樂特調：聽古典音樂大師劉岠渭的名曲導聆',
      //       titleCN: '古典乐特调：听古典音乐大师刘岠渭的名曲导聆',
      //       subtitle: '15分鐘輕鬆聽懂古典樂',
      //       subtitleCN: '15分钟轻松听懂古典乐',
      //       imgCover: 'https://test.jinfm.net/images/channels/61/cover.jpg',
      //       total: 2,
      //       author: {
      //         id: 30,
      //         title: '劉岠渭',
      //         titleCN: '刘岠渭',
      //         imgAvatar: 'https://prod.jinfm.net/images/authors/30/cover.jpg'
      //       }
      //     },
      //     total_copy: 99999,
      //     borrow_records_count: 0
      //   }

      // ]
      // 測試用data END
    }
  },

  created () {
    this.pageUrl = window.location.toString()
    const index = this.pageUrl.lastIndexOf('/')
    if (this.pageUrl.includes('?')) {
      this.pageUrl = this.pageUrl.split('?')[0]
    }
    this.clientId = this.pageUrl.substring(index + 1, this.pageUrl.length)
    this.getClientData(this.clientId)
  },
  mounted () {
    this.setQRCode(this.clientId)
  },
  methods: {
    getClientData (id) {
      this.axios
        .get(`${this.$store.getters.baseURL}clients/${id}`)
        .then(response => {
          // eslint-disable-next-line eqeqeq
          if (response.status == 200) {
            // console.log(response.data);
            this.introduction = response.data.introduction
            this.bannersList = response.data.client_banners
            this.client_assets = response.data.client_blocks[0].client_assets
            this.client_category = response.data.categories
            // 測試用
            // this.bannersList =  [...response.data.client_banners, ...this.addBannersList]
            // this.client_assets = [...this.client_assets, ...this.add_assets]
            this.sortClass(this.client_assets, 'add')
          } else if (response.includes('404')) {
            this.$router.push('/')
          }
        })
        .catch(error => console.log('log:' + error))
    },
    setQRCode (id) {
      const pageUrl = `${window.location.origin}/lib/${id}`
      const QRCodeValue = `https://jinfm.page.link/?link=${pageUrl}&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm`
      this.$store.commit('CLIENTS_QRCODE', QRCodeValue)
    },
    // 接收子層currentPage後重排課程列表
    changeListPage (val) {
      this.currentPage = val
      this.sortClass(this.client_assets, 'update')
    },
    // 點選課程分類後重排課程列表
    filterCourseList (categoryId) {
      const category = this.client_category.filter((category) => {
        return category.id === categoryId
      })
      // console.log(category);
      // console.log(category[0].channels);
      this.currentPage = 1
      this.api_current_page = 1
      this.sortClass(category[0].channels, 'add')
    },
    // 重排課程列表
    sortClass (classData, type) {
      // console.log(classData, type);
      if (type === 'add') {
        this.paginationClassData = []
        this.allCount = classData.length
        this.totalPages = Math.ceil(classData.length / 18)
        // console.log(this.allCount)
        // console.log(this.totalPages)

        let size = classData.length
        if (classData.length > 18) {
          size = 18
        }
        for (let i = 0; i < size; i++) {
          this.paginationClassData.push(classData[i])
        }
      } else {
        if (this.api_current_page !== this.currentPage) {
          this.paginationClassData = []
          this.allCount = classData.length

          let i = (this.currentPage - 1) * 18

          if (this.allCount > this.currentPage * 18) { // 最多18筆
            this.allCount = this.currentPage * 18
          }

          for (i; i < this.allCount; i++) {
            this.paginationClassData.push(classData[i])
          }

          this.api_current_page = this.currentPage
          this.scrollToList()
        }
      }
    },
    scrollToList () {
      window.scrollTo({
        top: this.$refs.categorys.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/clients.scss";

.about {
  position: relative;
  margin-top: 25px;
  .about_text {
    margin-bottom: 40px;
  }
}

.about_wrap {
  width: 80%;
  .about_title {
    color: #000;
    font-size: 62px;
    line-height: 76px;
    text-align: left;
  }
  .about_introduction {
    line-height: 24px;
  }
}

.vertical_text {
  position: relative;
  writing-mode: vertical-lr;
  font-size: 11px;
  &::after {
    content:"";
    background-color: #000;
    position: absolute;
    bottom: -40px;
    left: -22px;
    background: #aaa;
    width: 60px;
    height: 1px;
    transform: rotate(90deg);
  }

}

.about_banner {
  position: relative;
}
.scroll {
  position: absolute;
  top: -150px;
  right: 25px;
}

@media screen and (min-width: 576px){
  .about .about_text {
    margin-bottom: 45px;
  }
}

@media screen and (min-width: 768px){
  .about_wrap {
    width: 75%;
    .about_title {
      font-size: 80px;
      line-height: 112px;
    }
    .about_introduction {
      line-height: 35px;
    }
  }
  .about {
    display: flex;
    justify-content: space-between;
    .about_text,.about_banner {
      flex: 0 0 45%;
      max-width: 45%;
    }
    .about_text {
      margin-bottom: 0;
      .about_wrap {
        width: 100%;
      }
    }
    .about_banner {
      align-self: flex-end;
    }
    .scroll{
      position: static;
      .vertical_text {
        margin-right: 15px;
        margin-bottom: 95px;
        margin-left: auto;
      }
    }
  }
}

@media screen and (min-width: 1280px){
  .about_wrap {
    .about_title {
      font-size: 90px;
      line-height: 105px;
    }
    .about_introduction {
      line-height: 31px;
    }
  }
}

@media screen and (min-width: 1280px){
  .about_wrap {
    .about_title {
      font-size: 95px;
      line-height: 110px;
    }
    .about_introduction {
      line-height: 31px;
    }
  }
}

.category_list {
  margin-top: 15px;
}

//client_channels
.client_channels {
  margin-top: 60px;
}

.client_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .client_item {
    position: relative;
    margin-bottom: 30px;
    width: 100%;
    &:hover {
      color: #176e8d;
    }
    .item_flex {
      display: flex;
      align-items: stretch;
      margin-bottom: 13px;
      .item_content {
        >*:not(:last-child) {
          margin-bottom: 5px;
        }
      }
      .item_title {
        font-weight: bold;
        text-align: justify;
      }
      .item_content_text {
        line-height: 25px;
      }
      .item_author {
        font-weight: bold;
        margin-bottom: 3px;
      }
      .item_info {
        display: flex;
        justify-content: space-between;
      }
    }
    figure {
      position: relative;
      margin: 0;
      margin-right: 16px;
      flex: 0 0 100px;
      .org_img {
        border-radius: 20px;
        box-shadow: 0 0 15px hsla(0,0%,60%,.1);
      }
    }
    figcaption {
      flex: 1 1 auto;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    .client_item_link {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      display: block;
      text-indent: -9999px;
    }
  }
}

@media screen and (min-width: 600px){
  .client_list .client_item {
    flex-basis: calc(50% - 20px);
    margin-bottom: 40px;
  }
}

@media screen and (min-width: 768px){
  .client_list .client_item {
    flex-basis: calc(50% - 20px);
    figure {
      flex: 0 0 160px;
    }
  }
}

@media screen and (min-width: 1500px){
  .client_list {
    justify-content: flex-start;
    .client_item {
      flex-basis: calc(30%);
      &:not(:nth-child(3n)) {
        margin-right: 5%;
      }
    }
  }
}
//client_channels END

.pagiContainer {
  margin-bottom: 24px
}

</style>



// WEBPACK FOOTER //
// src/components/views/clients/ClientsCourseList/index.vue